// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'c30e345210e312102ff6cab780004ae9143bda30';
export const BUILD_NUMBER = '226';
export const BUILD_TIMESTAMP = '2026-09-07T06:52:14.253Z';
